import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsIconModule } from '@components/icon';
import { LoadingModule } from '@components/loading';
import { ToolbarTabsModule } from '@components/toolbar-tabs';
import { RegimenPropositionModule } from '@shared/regimen-proposition/regimen-proposition.module';
import { ChoosePlanInfoComponent } from './choose-plan-info.component';
import { ButtonModule } from '@components/button';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';

@NgModule({
  imports: [CommonModule, CsIconModule, ToolbarTabsModule, LoadingModule, RegimenPropositionModule, ButtonModule, ButtonCtaComponent],
  declarations: [ChoosePlanInfoComponent],
  exports: [ChoosePlanInfoComponent],
})

export class ChoosePlanInfoModule { }
